import { defineComponent, toRef } from 'vue';
import { LoadingTypes } from '@/models/loading.interface';
import LoadingWrapperCode from '@/presentation/components/shared/loading-wrapper/loading-wrapper.code';

export default defineComponent({
	props: {
		classes: {
			type: Array,
			required: true,
		},
		isLoading: {
			type: Boolean,
			required: true
		},
		tag: {
			type: String,
			required: false
		},
		loadingType: {
			type: String,
			required: false
		}
	},
	setup: (props) => {
		const code = new LoadingWrapperCode(
			props.loadingType as LoadingTypes || LoadingTypes.GENERIC
		);
		return {
			tag: props.tag || 'div',
			classes: toRef(props, 'classes'),
			isLoading: toRef(props, 'isLoading'),
			hasLoadingFailed: code.hasLoadingFailed,
			errorMessage: code.errorMessage,
			retryLoadingProcess: code.retryLoadingProcess.bind(code)
		};
	}
});
